<template>
  <custom-callout
    :border-color-hex="data.requestStatusColor"
    class="mb-3"
    :has-toggle="false"
  >
    <div class="row py-2 mr-md-0 n-ml">
      <div class="col-12 col-md-2 text-center border-right">
        <div
          :class="
            `badge badge-pill font-16 mt-3 py-2 ${getStatusWidth} mx-auto color-black`
          "
          :style="{ 'background-color': data.requestStatusColor }"
        >
          {{ data.requestStatusName }}
        </div>
      </div>
      <div class="col-12 col-md-10">
        <div class="row pt-2">
          <div class="col-12 col-md-5">
            <div class="row pl-2">
              <div class="col-12 col-md-7 pr-0">
                <div>
                  <span class="color-gray-6 d-block font-14">
                    Número de Propuesta:
                  </span>
                  <span class="font-16 color-black ">
                    {{ data.proposalNumber | empty }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-md-5 pr-0">
                <div>
                  <span class="color-gray-6 d-block font-14">
                    Tipo de Proponente:
                  </span>
                  <span class="font-16 color-black">
                    {{ data.proponentTypeName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-7 custom-pl">
            <div class="row">
              <div class="col-12 col-md-5 pr-0">
                <div>
                  <span class="color-gray-6 d-block font-14">
                    Nombre del Proponente:
                  </span>
                  <span class="font-16 color-black">
                    {{ data.providerName }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-md-4 pr-0 custom-pl">
                <div>
                  <span class="color-gray-6 d-block font-14">
                    Fecha de Sometido:
                  </span>
                  <span class="font-16 color-black">
                    {{ this.data.submittedDate | date }}
                  </span>
                </div>
              </div>
              <div
                class="col-12 col-md-3 d-inline d-md-flex align-items-center  justify-content-center"
              >
                <action-button
                  id="on-detail-btn-identifier"
                  i="fas fa-file-import"
                  variant="outline-success m-2 px-4"
                  @click="onDetailHanlder"
                >
                  Entrar
                </action-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import proposalStatus from '@/utils/shared/constants/proposalStatus';

const PROPOSAL_PROCESS_DETAIL = 'ServiceProposalDetails';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getStatusWidth() {
      switch (this.data.requestStatusId) {
        case proposalStatus.Recommendation:
          return 'custom-w-recommended';
        case proposalStatus.Not_Recommendation:
          return 'custom-w-not-recommended';
        case proposalStatus.Submitted:
          return 'custom-w-submitted';
        default: {
          return `custom-w-100`;
        }
      }
    },
  },
  methods: {
    onDetailHanlder() {
      this.$router.push({
        name: PROPOSAL_PROCESS_DETAIL,
        params: {
          proposalRequestId: this.data.id,
          readOnly: false,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.n-ml {
  margin-left: -1.5rem !important;
}

.custom-w-100,
.custom-w-recommended,
.custom-w-not-recommended,
.custom-w-submitted {
  width: 100%;
}

.custom-pl {
  padding-left: 15px;
}

@media (max-width: 1260px) {
  .custom-w-submitted {
    width: 108px;
  }
  .custom-w-recommended {
    width: 130px;
  }
  .custom-w-not-recommended {
    width: 150px;
  }
  .col-md-2 {
    padding-left: 0px !important;
  }
  .custom-pl {
    padding-left: 0px;
  }
}

@media (max-width: 767px) {
  .custom-w-recommended,
  .custom-w-not-recommended,
  .custom-w-submitted {
    width: 100%;
  }
}
</style>
